import type { HttpClient } from '../client';
import type { UserProfile } from '../types/auth';

export interface AlipayLoginRequest {
  /** 支付宝小程序 `my.getAuthCode({ scopes: 'auth_base' })` 取到的 authCode。 */
  code: string;
}

export interface AlipayLoginResult {
  token: string;
  tokenType: string;
  expiresInMinutes: number;
  profile: UserProfile;
  channel: string;
}

export interface AlipayBindResult {
  bound: boolean;
  thirdType: string;
  userIdMask: string | null;
  orgId: string;
  boundAt: string;
}

/**
 * 支付宝小程序免登（`alipay.system.oauth.token` 换 user_id）。
 * 凭据为「待补充…」占位时后端返回 42200，前端应回落到账号口令登录。
 */
export function createAlipayApi(http: HttpClient) {
  return {
    /** 免登：支付宝 user_id 已绑定则直接换 JWT。 */
    login(body: AlipayLoginRequest): Promise<AlipayLoginResult> {
      return http.request<AlipayLoginResult>({ path: '/alipay/login', method: 'POST', body });
    },

    /** 已登录账号绑定支付宝 user_id（换绑覆盖同 AppId 的旧记录）。 */
    bind(body: AlipayLoginRequest): Promise<AlipayBindResult> {
      return http.request<AlipayBindResult>({ path: '/alipay/bind', method: 'POST', body });
    }
  };
}

export type AlipayApi = ReturnType<typeof createAlipayApi>;
